import React, {Component} from 'react';

class LoginWithAmazon extends Component {
    constructor(props) {
        super(props);
        this.login = this.login.bind(this);
        this.buttonRef = React.createRef();
    }

    componentDidMount() {
        window.onAmazonLoginReady = function() {
            // eslint-disable-next-line no-undef
            amazon.Login.setClientId('amzn1.application-oa2-client.7084efaa3e4e477992a2956653a8a8f1');
        };
        (function(d) {
            let a = d.createElement('script'); a.type = 'text/javascript';
            a.async = true; a.id = 'amazon-login-sdk';
            a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
            a.onload = function() {
                console.log('[LwA] SDK loaded');
            };
            a.onerror = function(err) {
                console.error('[LwA] Failed to load Amazon Login SDK', err);
            };
            d.getElementById('amazon-root').appendChild(a);
        })(document);

        const btn = this.buttonRef.current;
        if (btn) {
            btn.addEventListener('click', this.login);
            console.log('[LwA] Bound native click listener to #LoginWithAmazon');
        } else {
            console.warn('[LwA] Button ref not found; cannot bind native click listener');
        }
    }

    login(e) {
        // prevent the anchor from navigating
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        console.log('[LwA] Login button clicked');

        // Ensure SDK is present
        if (!window.amazon || !window.amazon.Login) {
            console.error('[LwA] Amazon SDK not available. Check that the script loaded (ad blockers/CSP can block it).');
            return;
        }

        // Basic sanity check for clientId presence
        try {
            // eslint-disable-next-line no-undef
            if (!amazon || !amazon.Login) {
                console.error('[LwA] amazon.Login missing');
                return;
            }
        } catch (err) {
            console.error('[LwA] amazon global unavailable:', err);
            return;
        }

        const options = {
            scope: 'profile',
            response_type: 'code'
        };

        const redirectUri = window.location.origin + '/api/handle/login';
        console.log('[LwA] Authorizing with redirect URI:', redirectUri);

        // eslint-disable-next-line no-undef
        amazon.Login.authorize(options, redirectUri);
    }

    render() {
        return (
            <>
                <div id="amazon-root"></div>
                <button
                    type="button"
                    id="LoginWithAmazon"
                    ref={this.buttonRef}
                    onClick={this.login}
                    style={{ background: 'transparent', border: 0, padding: 0, cursor: 'pointer', pointerEvents: 'auto', position: 'relative', zIndex: 10 }}
                >
                    <img
                        border="0"
                        alt="Login with Amazon"
                        className={"ui centered"}
                        src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
                        width="156"
                        height="32"
                        style={{ pointerEvents: 'none' }}
                    />
                </button>
            </>
        )
    }
}

export default LoginWithAmazon;